import { Component, input } from '@angular/core';

export type NoContentMessageType = 'default' | 'fit-content';

@Component({
  selector: 'mbp-no-content-message',
  templateUrl: './mbp-no-content-message.component.html',
  styleUrls: ['./mbp-no-content-message.component.scss']
})
export class MbpNoContentMessageComponent {
  message1 = input<string>('');
  message2 = input<string>('');
  type = input<NoContentMessageType>('default');
}
